import { FormattedMessage } from 'react-intl';

import messages from './TimeoutSessionErrorModal.messages';
import styles from './TimeoutSessionErrorModal.module.css';
import { reloadCurrentLocation } from '../../../iwRouter/LocationHelper';
import { RefreshSVG } from '../../../svgComponents/refreshSVG';

const TimeoutSessionErrorModal = () => {
    return (
        <div className={styles.TimeoutSessionErrorModal}>
            <RefreshSVG className={styles.icon} />
            <div className={styles.label}>
                <FormattedMessage {...messages.label} />
            </div>
            <button
                className={styles.button}
                onClick={() => reloadCurrentLocation()}
            >
                <FormattedMessage {...messages.refresh} />
            </button>
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default TimeoutSessionErrorModal;
